import React, { useMemo } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useTranslation } from "react-i18next";
import { buildBreadcrumbItems } from "../../config/navigation/buildBreadcrumbs";
import { useBreadcrumbContext } from "../../contexts/BreadcrumbContext";
import {
  panelBreadcrumbWrapSx,
  panelBreadcrumbLinkSx,
  panelBreadcrumbCurrentSx,
  panelBreadcrumbMutedSx,
  panelBreadcrumbSeparatorSx,
} from "../../design-system/panel/panelBreadcrumbSx";

export default function PanelBreadcrumbs({ panelType = "doctor" }) {
  const { pathname } = useLocation();
  const { t } = useTranslation(["sidebar", "tenantDashboard", "common", "breadcrumbs", "permissionGroups", "collaborationGroups", "formulas", "team", "doctorProfile"]);
  const { labelOverride } = useBreadcrumbContext() || {};

  const translate = useMemo(
    () => (key, ns) => t(key, { ns, defaultValue: key }),
    [t]
  );

  const items = useMemo(
    () => buildBreadcrumbItems(pathname, panelType, translate, labelOverride),
    [pathname, panelType, translate, labelOverride]
  );

  if (pathname === "/AddPatient" || pathname === "/addpatient") return null;
  if (!items.length || (items.length === 1 && (pathname === "/dashboard" || pathname === "/tenant/dashboard" || pathname === "/tenant"))) return null;

  return (
    <Breadcrumbs
      aria-label={t("breadcrumbNav", { ns: "breadcrumbs", defaultValue: "Sayfa konumu" })}
      separator={<NavigateNextIcon sx={panelBreadcrumbSeparatorSx} fontSize="small" />}
      maxItems={4}
      itemsBeforeCollapse={1}
      itemsAfterCollapse={1}
      sx={panelBreadcrumbWrapSx}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const key = `${item.path || "current"}-${item.label}-${index}`;

        if (isLast) {
          return (
            <Typography key={key} component="span" sx={panelBreadcrumbCurrentSx}>
              {item.label}
            </Typography>
          );
        }

        if (!item.path) {
          return (
            <Typography key={key} component="span" sx={panelBreadcrumbMutedSx}>
              {item.label}
            </Typography>
          );
        }

        return (
          <Link
            key={key}
            component={RouterLink}
            to={item.path}
            underline="hover"
            sx={panelBreadcrumbLinkSx}
          >
            {item.label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}
